import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from './apiBase';
import { TAG_TYPES } from './apiBase.types';
import getAuthEndpoints from './endpoints/auth';
import getUserEndpoints from './endpoints/user';

export const API = createApi({
  reducerPath: 'API',
  baseQuery,
  tagTypes: TAG_TYPES,
  endpoints: builder => ({
    ...getAuthEndpoints(builder),
    ...getUserEndpoints(builder)
  })
});

export const {
  useCurrentSessionQuery,
  useGetCurrentUserQuery,
  useGetSubordinateInstitutionsQuery,
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation
} = API;
